import React, { useEffect } from "react";

import "./Vault.css";

import IgniteNavbar from "../../layout/IgniteNavbar";
import IgniteHeader from "../../layout/IgniteHeader";

import VaultHero from "./Components/VaultHero";
import AchievementProgress from "./Components/AchievementProgress";
import AchievementGrid from "./Components/AchievementGrid";

import HallOfFame from "./Components/HallOffFame";


const Vault = () => {
     useEffect(() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, []);
     // Hide website footer
      useEffect(() => {
        const navbar = document.querySelector("header, .navbar");
        const footer = document.querySelector("footer");
      
       
        if (navbar) navbar.style.display = "none";
        if (footer) footer.style.display = "none";
      
        return () => {
          // 🔥 மீண்டும் restore
          if (navbar) navbar.style.display = "";
          if (footer) footer.style.display = "";
        };
      }, []);

    return (

        <div className="ignite-vault">

            {/* =====================================
                SIDEBAR
            ===================================== */}

            <IgniteNavbar />


            {/* =====================================
                MAIN CONTENT
            ===================================== */}

            <main className="ignite-vault-main">

                {/* =================================
                    HEADER
                ================================= */}

                <IgniteHeader

                    title="Vault"

                    subtitle="Your achievements, rewards and progress."

                />


                {/* =================================
                    VAULT HERO
                ================================= */}

                <VaultHero />


                {/* =================================
                    ACHIEVEMENT PROGRESS
                ================================= */}

                <div className="vault-section">

                    <AchievementProgress />

                </div>


                {/* =================================
                    ACHIEVEMENT GRID
                ================================= */}

                <div className="vault-section">

                    <AchievementGrid />

                </div>


                {/* =================================
                    HALL OF FAME
                ================================= */}

                <div className="vault-section">

                    <HallOfFame />

                </div>

            </main>

        </div>

    );

};


export default Vault;